import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

export type MagicLinkVerifyResponse = {
  jwt_access: string
  jwt_refresh: string
  is_new_user: boolean
  is_profile_complete: boolean
}

export async function requestMagicLink(email: string, callbackUrl: string, intent: 'signin' | 'signup' = 'signin'): Promise<void> {
  await api.post(API_ROUTES.MAGIC_LINK_REQUEST, {
    email: email.trim(),
    link: callbackUrl,
    intent,
  })
}

export async function verifyMagicLinkToken(token: string): Promise<MagicLinkVerifyResponse> {
  const { data } = await api.post<MagicLinkVerifyResponse>(API_ROUTES.MAGIC_LINK_VERIFY, {
    token: token.trim()
  })
  return data
}
